export default __webpack_public_path__ + "static/media/support-illustration.89921d96.png";